import { createAction } from '@lifesize/typescript-react-redux-utils';
import { Ecommerce } from '@lifesize/types';
import {
  ECOMMERCE_ACCOUNT_FAILURE,
  ECOMMERCE_ACCOUNT_LOADED,
  ECOMMERCE_ACCOUNT_REQUEST
} from 'constants/ecommerceConstants';

const actions = {
  ecommerceAccountLoaded: (account: Ecommerce.Account) =>
    createAction(ECOMMERCE_ACCOUNT_LOADED, account),
  requestingEcommerceAccount: () =>
    createAction(ECOMMERCE_ACCOUNT_REQUEST),
  ecommerceAccountFailure: (error: string) =>
    createAction(ECOMMERCE_ACCOUNT_FAILURE, error)
};

export default actions;
